import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 60px;
`;

export const EstablishmentAndInputContainer = styled.div`
    display: flex;
    align-items: center;
    
    @media (max-width: 768px){
        width: 100%;
        display: block;
    }
`;

export const EstablishmentContainer = styled.div`
    display: flex;
    align-items: center;
    padding-right: 43px;
    border-right: solid 1px #E6E9F2;

    @media (max-width: 768px) {
        border: none;
        margin-bottom: 15px;
        justify-content: center;
        padding-right: 0px;
    }
`;

export const EstablishmentText = styled.h1`
    margin: 0;
    line-height: 1;
    margin-right: 20px;
    font: normal normal normal 27px Circular Std Book;
    color: #454546;

    @media (max-width: 1024px){
        font: normal normal normal 21px Circular Std Book;
    }
`;

export const PlusButton = styled.button`
    outline: 0;
    width: 34px;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #F58B1E;
    border: none;
    border-radius: 9px;
    font: normal normal normal 22px Circular Std Book;
    color: #FFFFFF;

    &:focus{
        outline: none;
    }

    @media (max-width: 1024px){
        width: 26px;
        height: 26px;
        border-radius: 7px;
        font: normal normal normal 16px Circular Std Book;
    }
`;

export const InputContainer = styled.div`
    width: 283px;
    margin-left: 43px;

    @media (max-width: 768px) {
        width: 70%;
        margin: auto;
    }

    @media (max-width: 500px) {
        width: 100%;
        margin: auto;
    }
`;

export const MessageAndUserContainer = styled.div`
    margin-right: 40px;
    display: flex;
    align-items: center;

    @media (max-width: 1024px){
        margin-right: 0px;
    }

    @media (max-width: 768px){
        display: none;
    }
`;

export const Message = styled.img`
    
`;

export const UserContainer = styled.div`
  display: flex;
  align-items: center;
  line-height: 0;
`;

export const UserName = styled.p`
  margin: 0px;
  font: normal normal normal 15px Circular Std Book;
  color: #454546;
  text-align: right;
`;

export const UserJob = styled.span`
  font: normal normal normal 12px Circular Std Book;
  color: #B8B4CC;
`;

export const UserImage = styled.img`
    max-width: 52px;
    max-height: 53px;
    height: auto;
    width: auto;
    object-fit: contain;

    border-radius: 13px;
`;

export const RedCircle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: red;
  margin-left: -5px;
  margin-top: -5px;
`;